import { render, staticRenderFns } from "./DataSynchronizationRatio.vue?vue&type=template&id=3d91241e&scoped=true&"
import script from "./DataSynchronizationRatio.vue?vue&type=script&lang=js&"
export * from "./DataSynchronizationRatio.vue?vue&type=script&lang=js&"
import style0 from "./DataSynchronizationRatio.vue?vue&type=style&index=0&id=3d91241e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d91241e",
  null
  
)

export default component.exports